import { render, staticRenderFns } from "./EntriesList.vue?vue&type=template&id=452b7f49&scoped=true"
import script from "./EntriesList.vue?vue&type=script&lang=js"
export * from "./EntriesList.vue?vue&type=script&lang=js"
import style0 from "./EntriesList.vue?vue&type=style&index=0&id=452b7f49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b7f49",
  null
  
)

export default component.exports